import { useRouter } from 'next/router'
import { useMemo } from 'react'

import { Product } from '@Generated/graphql'
import { getAvailableVariantsForProduct } from '@Globals/CMS/ProductHelpers'

type VariantFilterOptions = {
  includeVariantsThatWillNeverRestock?: boolean
  product?: Product
}

export const useFilteredVariants = (
  {
    includeVariantsThatWillNeverRestock,
    product,
  }: VariantFilterOptions,
) => {
  const { locale } = useRouter()

  return useMemo(
    () => getAvailableVariantsForProduct({ includeVariantsThatWillNeverRestock, locale, product }),
    [includeVariantsThatWillNeverRestock, locale, product],
  )
}
